<template>
  <div class=" incoming-message-widget">
    <div class="header-widget">
      <p>Daily Transactions</p>
    </div>
    <!-- <div class="card-body"> -->
      <!-- <div class="row">
        <div class="col-sm-12 col-xl-8"> -->
            <NoResultsFound v-if="isCountIncomingMsgAllZero" class="no-result-content"/>
            <div v-else class="chart-content">
              <GChart
              class="g-chart"
              type="LineChart"
              :data="incomingMessageHistoryChartData"
              :options="chartOptions"
              ></GChart>
            </div>
          <!-- </div>
        </div> -->
        <!-- <div class="col-sm-12 col-xl-4">
          <div class="row incoming-block-stat">
            <div class="col-12 col-sm-4 col-xl-12">
              <div class="stat-block">
                <div class="stat-label">INCOMING MESSAGES</div>
                <div class="stat-value">
                  <span>{{incomingMessageStat.totalIncomingMessage | number}}</span>
                  <span class="changes positive" v-if="incomingMessageStat.incomingMessageTrend>0">
                    <font-awesome-icon class="changes-icon" icon="chevron-up"></font-awesome-icon>
                    <span class="changes-value">
                      (+{{incomingMessageStat.incomingMessageTrend}}%)
                    </span>
                  </span>
                  <span
                    class="changes negative"
                    v-else-if="incomingMessageStat.incomingMessageTrend<0"
                  >
                    <font-awesome-icon class="changes-icon" icon="chevron-down"></font-awesome-icon>
                    <span class="changes-value">
                      ({{incomingMessageStat.incomingMessageTrend}}%)
                    </span>
                  </span>
                </div>
                <div class="list-item">
                  <font-awesome-icon class="icon" icon="dot-circle"></font-awesome-icon>
                  <span>avg {{incomingMessageStat.avgMessagePerUser}} messages/user</span>
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-4 col-xl-12">
              <div class="stat-block">
                <div class="stat-label">CONVERSATION</div>
                <div class="stat-value">
                  <span>{{conversationStat.totalConversation | number}}</span>
                  <span class="changes positive" v-if="conversationStat.conversationTrend>0">
                    <font-awesome-icon class="changes-icon" icon="chevron-up"></font-awesome-icon>
                    <span class="changes-value">(+{{conversationStat.conversationTrend}}%)</span>
                  </span>
                  <span class="changes negative" v-else-if="conversationStat.conversationTrend<0">
                    <font-awesome-icon class="changes-icon" icon="chevron-down"></font-awesome-icon>
                    <span class="changes-value">({{conversationStat.conversationTrend}}%)</span>
                  </span>
                </div>
                <div class="list-item">
                  <font-awesome-icon class="icon" icon="dot-circle"></font-awesome-icon>
                  <span>avg {{conversationStat.avgMessagePerConversation}} messages/user</span>
                </div>
                <div class="list-item">
                  <font-awesome-icon class="icon" icon="dot-circle"></font-awesome-icon>
                  <span>completed {{conversationStat.completeConversation}} conversations</span>
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-4 col-xl-12">
              <div class="stat-block">
                <div class="stat-label">CONVERSATION LENGTH</div>
                <div class="stat-value">
                  <span>{{convertTime(conversationStat.conversationLength)}}</span>
                  <span class="changes positive" v-if="conversationStat.conversationLengthTrend>0">
                    <font-awesome-icon class="changes-icon" icon="chevron-up"></font-awesome-icon>
                    <span class="changes-value">
                      (+{{conversationStat.conversationLengthTrend}}%)
                    </span>
                  </span>
                  <span
                    class="changes negative"
                    v-else-if="conversationStat.conversationLengthTrend<0"
                  >
                    <font-awesome-icon class="changes-icon" icon="chevron-down"></font-awesome-icon>
                    <span class="changes-value">
                      (-{{conversationStat.conversationLengthTrend}}%)
                    </span>
                  </span>
                </div>
                <div class="stat-value-unit">
                  {{convertUnit(conversationStat.conversationLength)}}
                </div>
              </div>
            </div>
          </div>
        </div> -->
      <!-- </div> -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { GChart } from 'vue-google-charts';
import moment from 'moment';
import NoResultsFound from '../NoResultsFound.vue';

export default {
  name: 'incoming-message-widget',
  components: {
    GChart,
    NoResultsFound
  },
  props: {
    criteria: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      chartOptions: {
        legend: 'none',
        chartArea: {
          top: 30,
          width: '90%',
          height: '80%',
        },
        hAxis: { showTextEvery: 4 },
        colors: ['#4FC0E8'],
      },
    };
  },
  watch: {
    criteria: {
      handler: 'init',
      immediate: true,
    },
  },
  methods: {
    ...mapActions({
      loadIncomingMessageData: 'dashboard/loadIncomingMessageData',
    }),
    async init() {
      await this.loadIncomingMessageData({
        criteria: this.criteria,
      });
    },
    convertTime(ms) {
      const input = moment.duration(ms);
      if (input.as('hours') >= 1) return input.as('hours').toFixed(2);
      if (input.as('minutes') >= 1) return input.as('minutes').toFixed(2);
      return input.as('seconds');
    },
    convertUnit(ms) {
      const input = moment.duration(ms);
      if (input.as('hours') >= 1) return 'hour(s)';
      if (input.as('minutes') >= 1) return 'minute(s)';
      if (input.as('seconds') >= 1) return 'second(s)';
      return 'second';
    },
    hAxisController(totalDataCount) {
      // Control displayed h-axis
      if (totalDataCount <= 10) {
        this.chartOptions.hAxis.showTextEvery = 1;
      } else if (totalDataCount > 10 && totalDataCount <= 20) {
        this.chartOptions.hAxis.showTextEvery = 2;
      } else {
        this.chartOptions.hAxis.showTextEvery = 4;
      }
    }
  },
  computed: {
    ...mapGetters({
      incomingMessageData: 'dashboard/incomingMessageData',
      incomingMessageStat: 'dashboard/incomingMessageStat',
      conversationStat: 'dashboard/conversationStat',
      incomingMessageHistory: 'dashboard/incomingMessageHistory',
    }),
    incomingMessageHistoryChartData() {
      const { criteria } = this;
      let header = ['Date', 'Messages'];
      let dateFormat = '';
      if (criteria) {
        if (criteria.time.granularity === 'month') {
          header = ['Month', 'Messages'];
          dateFormat = 'M/YY';
        } else if (criteria.time.granularity === 'day') {
          header = ['Date', 'Messages'];
          dateFormat = 'D/M/YY';
        } else if (criteria.time.granularity === 'hour') {
          header = ['Hour', 'Messages'];
          dateFormat = 'HH:mm';
        }
      }
      if (this.incomingMessageHistory) {
        const dataList = this.incomingMessageHistory.map((obj) => [
          moment(obj.date).format(dateFormat), obj.count,
        ]);
        this.hAxisController(dataList.length);
        return [header, ...dataList];
      }
      return [header, ['No data', 0]];
    },
    isCountIncomingMsgAllZero() {
      return !this.incomingMessageHistory.some((obj) => obj.count > 0);
    }
  },
};
</script>

<style lang="scss" scoped>
.incoming-message-widget{
  background-color: #FFFFFF;
    border-radius: 16px;

    .header-widget{
      padding: 16px 16px 12px 16px;
      border-bottom: 1px solid #E9EBEC;
      font-size: 16px;
      font-weight: 500;
      line-height: 19.2px;
      color: #111B49;
      display: flex;
      justify-content: space-between;
      p {
          margin-bottom: 0px
      }
    }
    .chart-content{
      padding: 20px;
      .g-chart{
        height: 300px;
      }
    }
    .no-result-content{
      margin-top: 97px;
      margin-bottom: 97px;
    }
  }
</style>
